import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateStyles } from '../../constants/CentricConstants';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

class ModuleBookingDialog extends Component {

    constructor() {
        super(...arguments);
        this.state = { value: this.props.selectedEvent || null };
    }

    componentDidMount() {
        this.onEventSelect = this.onEventSelect.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    render() {
        let title, content, buttonLabel;

        if (!this.props.booked) {
            title = 'Book place';
            buttonLabel = 'book';
        } else {
            title = 'Unbook';
            buttonLabel = 'unbook';
        }

        if (!this.props.events || this.props.events.length === 0) {
            title = 'Enrol';
            buttonLabel = 'enrol';
            content = 'You will be added to the waiting list';
        } else if (this.props.events.length === 1) {
            const start = new Date(this.props.events[0].timeStart).toLocaleString('en-GB', DateStyles.shortDateTime);
            const venue = !!this.props.events[0].venue ? ` - ${this.props.events[0].venue}` : '';
            content = `${start} ${venue}`;
        } else {
            content = (
                <SelectField
                    floatingLabelText="Select event"
                    onChange={this.onEventSelect}
                    value={this.state.value}
                    fullWidth
                >
                    {this.props.events.map((event) => {
                        const start = new Date(event.timeStart).toLocaleString('en-GB', DateStyles.shortDateTime);
                        const venue = !!event.venue ? ` - ${event.venue}` : '';
                        return (<MenuItem key={event.id} value={event.id} primaryText={`${start} ${venue}`}/>);
                    })}
                </SelectField>
            );
        }

        return (
            <Dialog
                title={title}
                open={this.props.open}
                modal={false}
                onRequestClose={this.onClose}
                actions={[
                    <FlatButton key="dialog_cancel" label="cancel" onTouchTap={this.onClose}/>,
                    <FlatButton key="dialog_book" label={buttonLabel} onTouchTap={this.onConfirm}/>
                ]}
            >
                {content}
            </Dialog>
        );
    }

    onClose() {
        this.props.cancelAction();
        this.setState({value: null});
    }

    onConfirm() {
        this.props.confirmAction(this.state.value);
        this.setState({value: null});
    }

    onEventSelect({target}, index, value) {
        this.setState({value});
    }
}

ModuleBookingDialog.propTypes = {
    booked:         PropTypes.bool.isRequired,
    confirmAction:  PropTypes.func.isRequired,
    cancelAction:   PropTypes.func.isRequired,
    events:         PropTypes.arrayOf(PropTypes.object),
    selectedEvent:  PropTypes.number,
    open:           PropTypes.bool
};

ModuleBookingDialog.defaultProps = {
    open: false
};

export default ModuleBookingDialog;
